  /* =============================================
     VIVAPETS SHOPIFY THEME — theme.js
     Volledig productie-klaar
     ============================================= */
  
  (function () {
    'use strict';
  
    // Reads a translated string set by layout/theme.liquid's
    // window.themeTranslations block (see translate-content metaobjects).
    // Falls back to the original Dutch text if translations aren't loaded.
    function t(key, fallback) {
      return (window.themeTranslations && window.themeTranslations[key]) || fallback;
    }
  
    // Locale-aware cart AJAX path (e.g. /en/cart.js, /de/cart/add.js). Shopify.routes.root
    // already resolves to the current locale/market prefix, so cart responses - including
    // translated product titles - match whichever language the visitor is actually browsing,
    // instead of a bare "/cart/..." path always falling back to the shop's default language.
    function cartUrl(path) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return root + path;
    }
  
    // Keep display-only product metadata in this browser, never on order lines: line item
    // properties (even "_"-prefixed ones) are passed on to the order and show up in Picqer.
    // Maps variant id -> canonical NL handle, or true when the variant is restricted but no
    // handle could be captured (display then falls back to the item's own product handle).
    var restrictedCartDisplay = {};
    try {
      var storedDisplay = JSON.parse(localStorage.getItem('vivapets.restrictedCartDisplay') || '{}');
      if (storedDisplay && typeof storedDisplay === 'object' && !Array.isArray(storedDisplay)) restrictedCartDisplay = storedDisplay;
    } catch (e) {}
    function saveRestrictedCartDisplay() {
      try { localStorage.setItem('vivapets.restrictedCartDisplay', JSON.stringify(restrictedCartDisplay)); } catch (e) {}
    }
    function rememberRestrictedCartDisplay(variantId, info) {
      if (info.restricted) restrictedCartDisplay[String(variantId)] = info.handle || true;
      else delete restrictedCartDisplay[String(variantId)];
      saveRestrictedCartDisplay();
    }
    // Drop entries for variants no longer in the cart, so the map doesn't outlive the cart
    // (e.g. after checkout) or keep a variant locked whose restriction was lifted since.
    function pruneRestrictedCartDisplay(cart) {
      if (!cart || !Array.isArray(cart.items)) return;
      var inCart = {};
      cart.items.forEach(function (item) { inCart[String(item.variant_id)] = true; });
      var changed = false;
      Object.keys(restrictedCartDisplay).forEach(function (id) {
        if (!inCart[id]) { delete restrictedCartDisplay[id]; changed = true; }
      });
      if (changed) saveRestrictedCartDisplay();
    }
    function getStoredNlHandle(variantId) {
      var stored = restrictedCartDisplay[String(variantId)];
      return typeof stored === 'string' ? stored : '';
    }
  
    // Is this variant DE-restricted (the same metafield ip-restrict.js/redirect-nl.js already
    // read), and if so, what is its CANONICAL (always-default-locale) product handle? Checked
    // at add-to-cart time so the resulting cart line item can be remembered - see
    // fixRestrictedCartItemNames() below for why both pieces are needed, not just the flag.
    //
    // The handle can only be captured reliably HERE, not later from the cart response: confirmed
    // live that a cart line item's own item.handle / item.product.handle follows the ACTIVE
    // locale's translated handle (e.g. "milbemax-katze" while browsing German) - fetching that
    // bare (no locale prefix) 404s, since the default/Dutch locale's route table only recognizes
    // "milbemax-kat". product.handle read directly off the page (not through cart.items) stays
    // canonical regardless of locale, which is exactly what data-nl-url and #add-to-cart-form's
    // data-product-handle were already built from (Work stream 14) - so they're reused here as
    // the source of truth, captured once at add-time before that distinction is lost.
    //
    // Deliberately NOT based on which specific button element triggered the add (an earlier
    // version checked btn.closest('[data-restrict-de]') - that missed the disclaimer-modal flow
    // entirely, since #add-to-cart-disclaimer-btn lives in the shared, global disclaimer modal in
    // footer.liquid, not inside any per-product wrap). Instead: look up the variant id itself,
    // via whichever source has it.
    function getRestrictDeInfo(variantId) {
      // Only relevant while Restriction mode is "Redirect to NL language" - this locking
      // behavior is specifically about an item that only exists in the cart because it was
      // redirected away from its German identity. Not valid for "Restrict (hide buy button +
      // show message)" or "Off" - with either of those, a restrict_de item should behave like
      // any other item and just follow the active language.
      var s = window.themeSettings || {};
      if (s.restrictMode !== 'redirect_nl') return { restricted: false, handle: null };
      return lookupRestrictDe(variantId);
    }
  
    // Mode-independent lookup of a variant's restrict_de flag (and canonical handle) from whichever
    // source on the page has it. Shared by getRestrictDeInfo() above and by the purchase gate of the
    // permanent IP range check (window.ipRange, further down), which must work in every active mode.
    function lookupRestrictDe(variantId) {
      var idStr = String(variantId);
  
      // PDP: #variant-data has every variant's restrict_de flag directly. #add-to-cart-form's
      // data-product-handle is only valid here if the form is currently reflecting THIS variant
      // (it always tracks whichever variant is selected).
      var dataEl = document.getElementById('variant-data');
      if (dataEl) {
        try {
          var variants = JSON.parse(dataEl.textContent).variants;
          var variant = variants.find(function (v) { return String(v.id) === idStr; });
          if (variant) {
            if (variant.restrict_de !== true) return { restricted: false, handle: null };
            var form = document.getElementById('add-to-cart-form');
            var vidEl = document.getElementById('variant-id-input');
            var handle = (form && vidEl && String(vidEl.value) === idStr) ? form.dataset.productHandle : null;
            return { restricted: true, handle: handle || null };
          }
        } catch (e) {}
      }
  
      // Collection grid / related products / PDP swiper: search the whole page for ANY
      // [data-add-variant] matching this id (not just the one actually clicked) and read its
      // ancestor wrap - this is what makes the disclaimer-modal flow work too, since that modal
      // still carries the correct variant id even though its own button isn't wrapped. data-nl-url
      // (already /products/<canonical handle>?variant=...) supplies the handle directly.
      var addBtns = document.querySelectorAll('[data-add-variant]');
      for (var i = 0; i < addBtns.length; i++) {
        if (addBtns[i].dataset.addVariant !== idStr) continue;
        var wrap = addBtns[i].closest('[data-restrict-de]');
        if (wrap) {
          var restricted = wrap.dataset.restrictDe === 'true';
          var match = restricted && wrap.dataset.nlUrl ? wrap.dataset.nlUrl.match(/\/products\/([^/?]+)/) : null;
          return { restricted: restricted, handle: match ? match[1] : null };
        }
      }
      return { restricted: false, handle: null };
    }
  
    // Shared, memoized visitor-country lookup (IP-based geolocation), reused by
    // ip-restrict.js / redirect-nl.js / auto-language-redirect.js so those 3 features
    // together ever trigger at most ONE fetch to Shopify's geolocation endpoint per page
    // load, instead of one each. Lazy: the fetch only actually fires the first time
    // something calls this - not unconditionally on every page load, since theme.js always
    // loads but each of those 3 features is independently opt-in via its own theme setting.
    var visitorCountryPromise = null;
    window.getVisitorCountry = function () {
      if (!visitorCountryPromise) {
        visitorCountryPromise = fetch(window.Shopify.routes.root + 'browsing_context_suggestions.json?country[enabled]=true')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            return (data.detected_values &&
              data.detected_values.country &&
              data.detected_values.country.handle || '').toUpperCase() || null;
          })
          .catch(function () { return null; });
      }
      return visitorCountryPromise;
    };
  
    // Coordination for scripts that might redirect on page load (auto-language-redirect.js,
    // redirect-nl.js's on-load check), so other code (the cookie-consent popup) can wait until
    // it's certain no redirect is about to happen before doing anything visible. A script calls
    // beginRedirectCheck() synchronously before it starts deciding, then finishRedirectCheck()
    // only if it decides NOT to redirect - if it does redirect, it deliberately never calls
    // finish, so anything waiting via afterRedirectChecks() simply never fires on this page
    // load, which is correct since the page is about to be replaced anyway. This avoids relying
    // on timing (e.g. "did the navigation finish before this callback ran"), which a real form
    // submission (not an instant redirect) doesn't reliably guarantee.
    var pendingRedirectChecks = 0;
    var redirectChecksIdleCallbacks = [];
    window.beginRedirectCheck = function () {
      pendingRedirectChecks++;
    };
    window.finishRedirectCheck = function () {
      pendingRedirectChecks = Math.max(0, pendingRedirectChecks - 1);
      if (pendingRedirectChecks === 0) {
        redirectChecksIdleCallbacks.forEach(function (fn) { fn(); });
        redirectChecksIdleCallbacks = [];
      }
    };
    window.afterRedirectChecks = function (callback) {
      if (pendingRedirectChecks === 0) {
        callback();
      } else {
        redirectChecksIdleCallbacks.push(callback);
      }
    };
  
    // Shared day/hour-window check (shop's local time, so it's independent of the visitor's
    // device clock), used by both ip-restrict.js's restrict_ip mode and redirect-nl.js's
    // redirect_nl mode - they share the same Theme settings > Restriction schedule. Deliberately
    // pure - takes just the days map (window.themeSettings.restrictionDays) and returns
    // true/false, with NO mode-checking inside it. Whether restrict_ip/redirect_nl is even the
    // active mode is feature-specific business logic that stays local to each file, same
    // separation of concerns as getVisitorCountry() not knowing about DE/country rules.
    window.isWithinShopHourWindow = function (daysMap) {
      var s = window.themeSettings || {};
      var today = daysMap && s.currentDayName && daysMap[s.currentDayName];
      if (!today) return true; // day data missing: don't let a config gap silently disable this
      var hour = s.shopHourNow;
      var start = today.start;
      var end = today.end;
      if (typeof hour !== 'number' || typeof start !== 'number' || typeof end !== 'number') return true;
      if (start === end) return true;
      if (start < end) return hour >= start && hour < end;
      return hour >= start || hour < end; // window wraps past midnight, e.g. 22-6
    };
  
    /* ─────────────────────────────────────────
       PERMANENT IP RANGE CHECK  (window.ipRange)
       The PHP endpoint (Theme settings > Restriction > "Permanent IP range check - endpoint URL",
       users.php) tells us whether this visit's CURRENT IP is inside a restricted range. A confirmed
       match writes a permanent marker in localStorage (no expiry): from then on this browser is
       restricted for restrict_de variants on the German storefront at ALL times - no country match,
       no day/hour schedule, no Block NL toggle needed - using the mode selected in Theme settings
       (ip-restrict.js hides the buy controls, redirect-nl.js redirects). Rules that never change:
         - "restricted:false" never clears a marker, and a failed request never creates one or is
           cached as "not matched".
         - One background request per tab session (visit id in sessionStorage); reloads and
           navigation reuse the stored result. The request is shared by every caller on the page.
         - General browsing never waits. Only add-to-cart for restrict_de variants on /de/ is blocked
           while the answer is unknown (see guardPurchase), with a Retry link if the check failed.
         - Restriction = Off, an empty endpoint URL, or the theme editor: no request at all; a saved
           marker is left untouched but not enforced.
       Browser-side enforcement only: visitors can clear storage or disable JavaScript.
    ───────────────────────────────────────── */
    (function initIpRange() {
      var s = window.themeSettings || {};
      var MARKER_KEY = 'vp_ip_marker';        // localStorage, permanent: "1"
      var VISIT_KEY = 'vp_ip_visit_id';       // sessionStorage: random id of this tab session
      var NEGATIVE_KEY = 'vp_ip_negative';    // sessionStorage: a valid "not matched" answer
      var NOTIFIED_KEY = 'vp_ip_notified';    // sessionStorage: e-mail status acknowledged
      var TIMEOUT_MS = 5000;
      var DONE_NOTIFICATIONS = ['sent', 'duplicate', 'not_required'];
      var ALL_NOTIFICATIONS = ['sent', 'duplicate', 'not_required', 'failed'];
  
      var enabled = !!s.ipCheckUrl && !!s.restrictMode && s.restrictMode !== 'restrict_off' && !s.designMode;
      var mem = { marker: false, visitId: null, negative: false, notified: false }; // used when storage is unavailable
      var marked = false;
      var markerPersisted = false;
      var state = 'disabled';                 // disabled | marked | checking | clear | error
      var pending = null;                     // the one shared in-flight request
      var noticeWanted = false;
      var noticeEl = null;
  
      function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
      function lsSet(k, v) { try { window.localStorage.setItem(k, v); return window.localStorage.getItem(k) === v; } catch (e) { return false; } }
      function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
      function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  
      function flagGet(key, memKey) { return mem[memKey] || ssGet(key) === '1'; }
      function flagSet(key, memKey) { mem[memKey] = true; ssSet(key, '1'); }
  
      function newUuid() {
        var c = window.crypto;
        if (c && typeof c.randomUUID === 'function') return c.randomUUID();
        var b = new Uint8Array(16), i;
        if (c && typeof c.getRandomValues === 'function') c.getRandomValues(b);
        else for (i = 0; i < 16; i++) b[i] = Math.floor(Math.random() * 256);
        b[6] = (b[6] & 0x0f) | 0x40;
        b[8] = (b[8] & 0x3f) | 0x80;
        var h = [];
        for (i = 0; i < 16; i++) h.push((b[i] + 256).toString(16).slice(1));
        return h.slice(0, 4).join('') + '-' + h.slice(4, 6).join('') + '-' + h.slice(6, 8).join('') + '-' +
               h.slice(8, 10).join('') + '-' + h.slice(10).join('');
      }
  
      // Same id for every request of this tab session (a retry after a timeout MUST reuse it, so the
      // server can de-duplicate the e-mail); a new tab session generates a new one.
      function visitId() {
        if (mem.visitId) return mem.visitId;
        var v = ssGet(VISIT_KEY);
        if (!v || !/^[A-Za-z0-9\-]{16,64}$/.test(v)) {
          v = newUuid();
          ssSet(VISIT_KEY, v);
        }
        mem.visitId = v;
        return v;
      }
  
      // Site id from the shop metafield custom.sites_id (same source and fallback 8 as cr-reviews.js).
      function sitesId() {
        return Number(window.themeSettings && window.themeSettings.sitesId) || 8;
      }
  
      function dispatchMarked() {
        try { document.dispatchEvent(new CustomEvent('vp:ip-marked')); } catch (e) {}
      }
  
      // Becomes marked (first time in this page). Never called to UNmark - a marker only ever goes one way.
      function markNow(persist) {
        var first = !marked;
        marked = true;
        mem.marker = true;
        if (persist) {
          markerPersisted = lsSet(MARKER_KEY, '1');
          if (!markerPersisted && window.console && console.warn) {
            console.warn('IP range marker could not be saved to localStorage; it is kept in memory for this page only.');
          }
        }
        state = 'marked';
        refreshNotice();
        if (first) dispatchMarked();
      }
  
      function isUnknown() { return enabled && !marked && (state === 'checking' || state === 'error'); }
  
      function request(previouslyMarked) {
        return new Promise(function (resolve, reject) {
          var done = false;
          var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
          var timer = setTimeout(function () {
            if (done) return;
            done = true;
            if (ctrl) ctrl.abort();
            reject(new Error('timeout'));
          }, TIMEOUT_MS);
          fetch(s.ipCheckUrl, {
            method: 'POST',
            mode: 'cors',
            credentials: 'omit',
            cache: 'no-store',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ visitId: visitId(), previouslyMarked: previouslyMarked, sitesId: sitesId() }),
            signal: ctrl ? ctrl.signal : undefined
          })
            .then(function (r) {
              if (!r.ok) throw new Error('HTTP ' + r.status);
              return r.json();
            })
            .then(function (data) {
              if (done) return;
              done = true;
              clearTimeout(timer);
              resolve(data);
            })
            .catch(function (err) {
              if (done) return;
              done = true;
              clearTimeout(timer);
              reject(err);
            });
        });
      }
  
      function onSuccess(data) {
        var valid = data && typeof data.restricted === 'boolean' && ALL_NOTIFICATIONS.indexOf(data.notification) !== -1;
        if (!valid) { onFailure(new Error('invalid response')); return; }
  
        if (data.restricted) {
          markNow(true);                                    // confirmed match: permanent marker
        } else if (!marked) {
          flagSet(NEGATIVE_KEY, 'negative');                // valid "no": reuse for this tab session only
          state = 'clear';
          refreshNotice();
        } else {
          state = 'marked';                                 // "false" never clears an existing marker
          refreshNotice();
        }
        if (DONE_NOTIFICATIONS.indexOf(data.notification) !== -1) flagSet(NOTIFIED_KEY, 'notified');
        // notification "failed": not marked as done, so a later page of this session tries again
        // with the same visit id - the detection result above is unaffected.
      }
  
      function onFailure(err) {
        if (window.console && console.warn) console.warn('IP range check failed:', err && err.message);
        if (!marked) state = 'error';                       // never a marker, never cached as "not matched"
        refreshNotice();
      }
  
      function check() {
        if (pending) return pending;
        var previouslyMarked = marked;
        if (!marked) { state = 'checking'; refreshNotice(); }
        pending = request(previouslyMarked).then(
          function (data) { pending = null; onSuccess(data); },
          function (err) { pending = null; onFailure(err); }
        );
        return pending;
      }
  
      function retry() { return check(); }
  
      // ---- purchase gate ---------------------------------------------------------------------
      function ensureNotice() {
        if (noticeEl) return noticeEl;
        noticeEl = document.createElement('div');
        noticeEl.className = 'vp-ip-notice';
        noticeEl.setAttribute('role', 'status');
        noticeEl.setAttribute('aria-live', 'polite');
        noticeEl.hidden = true;
        var text = document.createElement('span');
        text.className = 'vp-ip-notice__text';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'vp-ip-notice__retry';
        btn.textContent = t('text-js-ip-check-retry', 'Erneut versuchen');
        btn.addEventListener('click', retry);
        noticeEl.appendChild(text);
        noticeEl.appendChild(btn);
        (document.body || document.documentElement).appendChild(noticeEl);
        return noticeEl;
      }
  
      function refreshNotice() {
        if (!noticeEl) return;
        if (!noticeWanted || !isUnknown()) { noticeEl.hidden = true; noticeWanted = false; return; }
        var failed = state === 'error';
        noticeEl.querySelector('.vp-ip-notice__text').textContent = failed
          ? t('text-js-ip-check-failed', 'Die Pr\u00fcfung ist fehlgeschlagen. Der Kauf ist vor\u00fcbergehend nicht m\u00f6glich.')
          : t('text-js-ip-check-pending', 'Wir pr\u00fcfen Ihre Verbindung. Bitte einen Moment Geduld.');
        noticeEl.querySelector('.vp-ip-notice__retry').hidden = !failed;
        noticeEl.hidden = false;
      }
  
      // true = this add-to-cart must NOT go ahead right now. Only restrict_de variants on the German
      // storefront are affected, and only while the answer is unknown (check running, or failed).
      function guardPurchase(variantId) {
        if (!isUnknown()) return false;
        if (s.currentLanguage !== 'DE') return false;
        if (lookupRestrictDe(variantId).restricted !== true) return false;
        ensureNotice();
        noticeWanted = true;
        refreshNotice();
        return true;
      }
  
      window.ipRange = {
        isEnabled: function () { return enabled; },
        isMarked: function () { return enabled && marked; },
        isUnknown: isUnknown,
        state: function () { return state; },
        markerPersisted: function () { return markerPersisted; },
        guardPurchase: guardPurchase,
        retry: retry
      };
  
      // ---- start ---------------------------------------------------------------------------
      // A marker saved by another tab (or this one on an earlier page) activates here too.
      window.addEventListener('storage', function (e) {
        if (!enabled || marked || e.key !== MARKER_KEY || e.newValue !== '1') return;
        markerPersisted = true;
        markNow(false);
      });
  
      if (!enabled) return;                                 // Off / no URL / theme editor: nothing runs
  
      if (lsGet(MARKER_KEY) === '1') { marked = true; markerPersisted = true; mem.marker = true; state = 'marked'; }
  
      if (marked) {
        if (!flagGet(NOTIFIED_KEY, 'notified')) check();    // restrictions already apply; tell the owner once per tab session
      } else if (flagGet(NEGATIVE_KEY, 'negative')) {
        state = 'clear';
      } else {
        check();
      }
    })();
  
    /* ─────────────────────────────────────────
       1. NAV DRAWER (slide-in van links)
    ───────────────────────────────────────── */
    var menuToggle    = document.getElementById('mobile-menu-toggle');
    var navDrawer     = document.getElementById('nav-drawer');
    var navOverlay    = document.getElementById('nav-drawer-overlay');
    var navCloseBtn   = document.getElementById('nav-drawer-close');
  
    function openNavDrawer() {
      if (!navDrawer) return;
      navDrawer.classList.add('is-open');
      navOverlay && navOverlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      navDrawer.focus();
      menuToggle && menuToggle.setAttribute('aria-expanded', 'true');
    }
  
    function closeNavDrawer() {
      if (!navDrawer) return;
      navDrawer.classList.remove('is-open');
      navOverlay && navOverlay.classList.remove('is-visible');
      document.body.style.overflow = '';
      menuToggle && menuToggle.setAttribute('aria-expanded', 'false');
    }
  
    if (menuToggle) menuToggle.addEventListener('click', openNavDrawer);
    if (navCloseBtn) navCloseBtn.addEventListener('click', closeNavDrawer);
    if (navOverlay)  navOverlay.addEventListener('click', closeNavDrawer);
  
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeNavDrawer();
    });
  
    /* ─────────────────────────────────────────
       1b. SEARCH TOGGLE (nieuwe header stijl)
    ───────────────────────────────────────── */
    var searchToggle = document.getElementById('search-toggle');
    var searchFormWrap = document.getElementById('search-form-wrap');
    if (searchToggle && searchFormWrap) {
      searchToggle.addEventListener('click', function () {
        var isOpen = searchFormWrap.classList.toggle('is-open');
        searchToggle.setAttribute('aria-expanded', String(isOpen));
        if (isOpen) {
          var searchInput = searchFormWrap.querySelector('input[type="search"]');
          if (searchInput) searchInput.focus();
        }
      });
    }
  
    /* ─────────────────────────────────────────
       2. STICKY HEADER SHADOW
    ───────────────────────────────────────── */
    var header = document.getElementById('site-header');
    if (header) {
      window.addEventListener('scroll', function () {
        header.classList.toggle('is-scrolled', window.scrollY > 10);
      }, { passive: true });
    }
  
    /* ─────────────────────────────────────────
       3. BACK TO TOP (hidden via CSS for now - see theme.css - JS kept working underneath)
    ───────────────────────────────────────── */
    var backToTopBtn = document.getElementById('back-to-top');
    if (backToTopBtn) {
      window.addEventListener('scroll', function () {
        backToTopBtn.classList.toggle('is-visible', window.scrollY > 400);
      }, { passive: true });
      backToTopBtn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  
    /* ─────────────────────────────────────────
       4. CART DRAWER
    ───────────────────────────────────────── */
    var cartDrawer    = document.getElementById('cart-drawer');
    var cartOverlay   = document.getElementById('cart-drawer-overlay');
    var cartCloseBtn  = document.getElementById('cart-drawer-close');
    var cartCount     = document.getElementById('cart-count');
    var drawerCount   = document.getElementById('drawer-item-count');
    var drawerSubtotal = document.getElementById('drawer-subtotal');
    var cartNotif     = document.getElementById('cart-notification');
  
    function openCartDrawer() {
      if (!cartDrawer) return;
      cartDrawer.classList.add('is-open');
      cartOverlay && cartOverlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      cartDrawer.focus();
    }
    // Globaal beschikbaar voor product.liquid
    window.openCartDrawer    = openCartDrawer;
    window.refreshCartDrawer = refreshCartDrawer;
  
    // Attempt 2 at fixing donation's position at Shopify's real checkout (see attempt 1,
    // reverted - resequencing on every add-to-cart added noticeable latency AND, worse, pushed
    // donation the wrong way since checkout orders newest-added-first, not oldest-first).
    //
    // This version does nothing during shopping - only runs once, in the background, after the
    // drawer is closed (so it never delays an add-to-cart click), and only touches the cart at
    // all if donation genuinely isn't in the correct position yet.
    //
    // Mechanism: Shopify's own cart.js array is already in real newest-first order, so
    // items[items.length - 1] IS the oldest item - if that's already donation, there's nothing
    // to fix (the common case once this has run once). Otherwise, every OTHER item is re-added
    // (remove then re-add, preserving quantity/properties) without ever touching the donation
    // line itself - since Shopify always treats the most-recently-touched line as newest, this
    // makes every other item newer than donation by definition, so donation becomes the true
    // oldest item and lands last at checkout, without needing to know or set any timestamp.
    function resequenceDonationOnClose() {
      var donationVariantId = window.themeSettings && window.themeSettings.donationVariantId;
      if (!donationVariantId) return;
  
      return fetch(cartUrl('cart.js'))
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = cart.items;
          if (!items.length) return;
          var donationLine = items.find(function (i) { return i.variant_id === donationVariantId; });
          if (!donationLine) return; // not in cart
  
          // Donation should never be the only thing left in the cart (e.g. every other item
          // got removed on a different page/flow that didn't go through the normal
          // "removing the last item also removes donation" path - a language switch mid-cart
          // was one way this was seen). If it's alone, remove it rather than leave it stranded
          // with a disabled, un-removable switch.
          var nonDonationCount = items.reduce(function (sum, i) {
            return i.variant_id === donationVariantId ? sum : sum + i.quantity;
          }, 0);
          if (nonDonationCount === 0) {
            return fetch(cartUrl('cart/change.js'), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: donationLine.key, quantity: 0 })
            })
              .then(function () { return fetch(cartUrl('cart.js')).then(function (r) { return r.json(); }); })
              .then(function (freshCart) { updateCartUI(freshCart); });
          }
  
          var lastItem = items[items.length - 1];
          if (lastItem.variant_id === donationVariantId) return; // already oldest - nothing to fix
  
          var toReAdd = items.filter(function (i) { return i.variant_id !== donationVariantId; }).reverse();
  
          var chain = toReAdd.reduce(function (p, item) {
            return p
              .then(function () {
                return fetch(cartUrl('cart/change.js'), {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: item.key, quantity: 0 })
                });
              })
              .then(function () {
                var addBody = { id: item.variant_id, quantity: item.quantity };
                if (item.properties && Object.keys(item.properties).length) addBody.properties = item.properties;
                return fetch(cartUrl('cart/add.js'), {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(addBody)
                });
              });
          }, Promise.resolve());
  
          return chain
            .then(function () { return fetch(cartUrl('cart.js')).then(function (r) { return r.json(); }); })
            .then(function (freshCart) { updateCartUI(freshCart); });
        })
        .catch(function () {}); // best-effort background fix - a failure here shouldn't surface to the visitor
    }
  
    function closeCartDrawer() {
      if (!cartDrawer) return;
      cartDrawer.classList.remove('is-open');
      cartOverlay && cartOverlay.classList.remove('is-visible');
      document.body.style.overflow = '';
      resequenceDonationOnClose();
    }
  
    if (cartCloseBtn)  cartCloseBtn.addEventListener('click',  closeCartDrawer);
    if (cartOverlay)   cartOverlay.addEventListener('click',   closeCartDrawer);
    document.getElementById('drawer-continue-shopping')?.addEventListener('click', closeCartDrawer);
  
    // Checking out directly from the drawer (without closing it first) skipped the same
    // resequenceDonationOnClose() step above entirely, since it's only ever wired to the
    // close action - so donation could still land in the wrong position at checkout in that
    // path. Does nothing extra when donation isn't configured (same no-op guard as the
    // function itself); when it is, the click waits for the resequence check (one cheap
    // cart.js fetch, more only if a real fix is needed) before navigating, capped at 3s so a
    // slow network never traps the visitor on the drawer.
    var cartCheckoutLink = document.querySelector('.cart-drawer__checkout');
    if (cartCheckoutLink) {
      cartCheckoutLink.addEventListener('click', function (e) {
        if (!(window.themeSettings && window.themeSettings.donationVariantId)) return;
  
        e.preventDefault();
        var href = cartCheckoutLink.href;
        var navigated = false;
        var goToCheckout = function () {
          if (navigated) return;
          navigated = true;
          window.location.href = href;
        };
        Promise.resolve(resequenceDonationOnClose()).then(goToCheckout).catch(goToCheckout);
        setTimeout(goToCheckout, 3000);
      });
    }
  
    // Escape-toets sluit drawer
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCartDrawer();
    });
  
    // Klikken op winkelwagen-icoon opent drawer
    document.querySelector('.header__cart-icon')?.addEventListener('click', function (e) {
      e.preventDefault();
      refreshCartDrawer().then(openCartDrawer);
    });
  
    // Ververs drawer inhoud via /cart.js
    function refreshCartDrawer() {
      return fetch(cartUrl('cart.js'))
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartUI(cart);
          renderDrawerItems(cart);
          return cart;
        });
    }
  
    function updateCartUI(cart) {
      if (cartCount)    cartCount.textContent    = cart.item_count;
      if (drawerCount)  drawerCount.textContent  = '(' + cart.item_count + ')';
      if (drawerSubtotal) drawerSubtotal.textContent = formatMoney(cart.total_price);
      var footerCartCount = document.getElementById('footer-cart-count');
      if (footerCartCount) footerCartCount.textContent = cart.item_count;
  
      // Keep the donation checkbox in sync with actual cart contents
      // (not just its own last click) on every refresh.
      var donationCheckbox = document.getElementById('drawer-donation-checkbox');
      if (donationCheckbox) {
        var donationVariantId = parseInt(donationCheckbox.dataset.variantId);
        var donationItem = cart.items.find(function (item) { return item.variant_id === donationVariantId; });
        donationCheckbox.checked = !!donationItem;
        var nonDonationCount = cart.item_count - (donationItem ? donationItem.quantity : 0);
        donationCheckbox.disabled = nonDonationCount === 0;
        donationCheckbox.closest('.cart-drawer__donation')?.classList.toggle('cart-drawer__donation--disabled', nonDonationCount === 0);
      }
  
      pruneRestrictedCartDisplay(cart);
    }
    // Globaal beschikbaar
    window.updateCartUI = updateCartUI;
  
    function formatMoney(cents) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
  
    // A restricted cart line item (remembered in restrictedCartDisplay at add-time, or tagged
    // _restrict_de by older theme versions - see getRestrictDeInfo() / window.addToCart above)
    // keeps its Dutch name in the cart/drawer permanently, even after the visitor switches the
    // storefront's active language - showing "Hund" instead of "Hond" once the visitor is
    // browsing in German would contradict the whole point of the item being excluded from its
    // German identity in the first place. Both places that render a cart line item - the initial
    // server render in snippets/cart-drawer-item.liquid, and this file's own renderDrawerItems()
    // on every AJAX add/change/remove - mark the title element with data-restrict-de-item plus
    // data-nl-handle/data-variant-id, which this function scans for and corrects.
    //
    // Fetches /products/<handle>.js with NO locale prefix - the exact opposite of cartUrl(),
    // which deliberately follows the current locale everywhere else in the cart. A bare product
    // fetch always resolves to this store's default language (Dutch), regardless of which
    // language the visitor is currently browsing in.
    //
    // data-nl-handle (the canonical handle captured at add-time - see getRestrictDeInfo) is used
    // instead of the item's own product handle: confirmed live that a cart line item's handle
    // follows the ACTIVE locale's translated handle (e.g. "milbemax-katze" once the visitor is
    // browsing German), which 404s when fetched bare - only the canonical/default-locale handle
    // ("milbemax-kat") resolves correctly without a locale prefix. Falls back to whatever locale
    // handle the item itself carries only if the canonical one somehow wasn't captured.
    function fixRestrictedCartItemNames() {
      // Same mode gate as getRestrictDeInfo() (add-time), but checked again here at DISPLAY
      // time: if a merchant switches Restriction mode away from "Redirect to NL language" after
      // an item was already tagged, that item should stop being locked too - it should show
      // whatever the active language would normally show, same as any other cart item.
      var s = window.themeSettings || {};
      if (s.restrictMode !== 'redirect_nl') return;
  
      // Cart title elements only - variant cards on product pages carry data-variant-id too,
      // and must never have their content replaced.
      document.querySelectorAll('.cart-drawer__item-title[data-variant-id]').forEach(function (el) {
        var remembered = !!restrictedCartDisplay[String(el.dataset.variantId)];
        if (!remembered && el.dataset.restrictDeItem !== 'true') return;
        var handle = getStoredNlHandle(el.dataset.variantId) || el.dataset.nlHandle || el.dataset.productHandle;
        if (!handle) return;
        fetch('/products/' + handle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (!data) return;
            var variantId = Number(el.dataset.variantId);
            var variant = data.variants && data.variants.find(function (v) { return v.id === variantId; });
            var hasRealVariant = variant && variant.title && variant.title !== 'Default Title';
            el.textContent = hasRealVariant ? variant.title : data.title;
          })
          .catch(function () {});
      });
    }
    window.fixRestrictedCartItemNames = fixRestrictedCartItemNames;
    // Fix the initial, server-rendered drawer content (snippets/cart-drawer.liquid), which is
    // present on every page load before any AJAX cart update happens.
    fixRestrictedCartItemNames();
  
    // Display-only mapping for unit_price_measurement.reference_unit, mirrors
    // snippets/unit-price-label.liquid. Shopify's raw values are uppercase
    // abbreviations (KG, ML, L, ITEM, ...).
    var UNIT_PRICE_LABELS = { MG: 'mg', G: 'g', KG: 'kg', ML: 'ml', L: 'l', ITEM: 'pcs' };
    window.formatUnitLabel = function (unit) {
      if (!unit) return '';
      var upper = String(unit).toUpperCase();
      return UNIT_PRICE_LABELS[upper] || String(unit).toLowerCase();
    };
  
    /* ─────────────────────────────────────────
       5. AJAX ADD TO CART
    ───────────────────────────────────────── */
    window.addToCart = function(variantId, quantity, btn) {
      // Permanent IP range check: restrict_de variants on /de/ wait until the check has answered.
      if (window.ipRange && window.ipRange.guardPurchase(variantId)) return Promise.resolve();
  
      var origHTML = btn ? btn.innerHTML : '';
      if (btn) { btn.innerHTML = '<span class="btn-spinner"></span> ' + t('text-js-adding-to-cart', 'Toevoegen') + '...'; btn.disabled = true; }
  
      var addBody = { id: variantId, quantity: quantity || 1 };
      var restrictInfo = getRestrictDeInfo(variantId);
      rememberRestrictedCartDisplay(variantId, restrictInfo);
  
      return fetch(cartUrl('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(addBody)
      })
        .then(function (r) { return r.json(); })
        .then(function (item) {
          if (item.status === 422) throw new Error(item.description);
  
          // Update cart count
          return fetch(cartUrl('cart.js')).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartUI(cart);
  
          if (btn) {
            btn.innerHTML = '✓ ' + t('text-js-added-to-cart-check', 'Toegevoegd') + '!';
            // btn.style.background = '#27ae60';
            setTimeout(function () {
              btn.innerHTML = origHTML;
              btn.style.background = '';
              btn.disabled = false;
            }, 2000);
          }
  
          // Open drawer als ingesteld
          var cartType = document.body.dataset.cartType;
          if (cartType !== 'page') {
            refreshCartDrawer().then(openCartDrawer);
          }
        })
        .catch(function (err) {
          if (btn) { btn.innerHTML = origHTML; btn.disabled = false; }
          showCartNotification(err.message || t('text-js-generic-error', 'Er ging iets mis. Probeer opnieuw.'), 'error');
        });
    }
  
    /* ─────────────────────────────────────────
       5b. AJAX ADD TO CART - VARIANT CARD BUTTONS
       Delegated (document-level) so it also works for
       markup injected later via AJAX (e.g. related products).
    ───────────────────────────────────────── */
    // Capture phase: must run and stopPropagation() BEFORE this click can
    // reach an ancestor's own click listener (e.g. .variant-card__trigger),
    // same as the old per-button, non-delegated listener used to guarantee.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-variant]');
      if (!btn) return;
      e.stopPropagation();
  
      var id = btn.dataset.addVariant;
      var disclaimer = btn.dataset.disclaimer;
      var qty = 1;
  
      // Routed through the same addCartCheck() used by .product-card__form/PDP submissions
      // (defined below - hoisted function declaration, same IIFE scope), so a customer who
      // already accepted the disclaimer this session isn't asked again just because they're
      // buying from a collection grid / related products / the PDP swiper instead.
      addCartCheck(id, qty, btn, disclaimer);
    }, true);
  
    // Product card formulieren
    document.querySelectorAll('.product-card__form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var id  = form.querySelector('[name="id"]').value;
        var disclaimer  = parseInt(form.querySelector('[name="disclaimer"]')?.value || 0);
        var qty = parseInt(form.querySelector('[name="quantity"]')?.value || 1);
        var btn = form.querySelector('button[type="submit"]');
        addCartCheck(id, qty, btn, disclaimer);
      });
    });
  
    // Product pagina formulier
    var productForm = document.getElementById('add-to-cart-form');
    if (productForm) {
      productForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var idEl = document.getElementById('variant-id-input')
                 || document.getElementById('variant-id')
                 || productForm.querySelector('[name="id"]');
        if (!idEl) return;
        var id  = idEl.value;
        var disclaimer  = parseInt(document.getElementById('disclaimer')?.value || 0);
        var qty = parseInt(document.getElementById('qty')?.value || 1);
        var btn = document.getElementById('add-to-cart-btn');
        addCartCheck(id, qty, btn, disclaimer);
      });
    }
  
    // Disclaimer modal formulier
    var disclaimerForm = document.getElementById('add-to-cart-disclaimer-form');
    if (disclaimerForm) {
      disclaimerForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var idEl = document.getElementById('disclaimer-variantId');
        var id  = idEl.value;
        var qty = parseInt(document.getElementById('disclaimer-quantity')?.value || 1);
        var btn = document.getElementById('add-to-cart-disclaimer-btn');
       
        addToCart(id, qty, btn);
       
        setTimeout(function () {
            document.querySelector('.disclaimer-modal__close').click();
        }, 1500);  // Close after 1.5 seconds
  
      });
    }
  
    function addCartCheck(id, qty, btn, disclaimer) {
      // Same gate as in addToCart, checked first so the disclaimer modal is not opened for a blocked purchase.
      if (window.ipRange && window.ipRange.guardPurchase(id)) return;
  
      if( disclaimer == '1' && localStorage.getItem('disclaimerAccepted') !== '1' )
      {
        openCartDisclaimerModal(id, qty);
      }
      else
      {
        addToCart(id, qty, btn);
      }
    }
  
    /* ─────────────────────────────────────────
       6. CART NOTIFICATIE TOAST
    ───────────────────────────────────────── */
    function showCartNotification(message, type) {
      if (!cartNotif) return;
      cartNotif.textContent = message;
      cartNotif.className = 'cart-notification cart-notification--' + (type || 'success') + ' is-visible';
      clearTimeout(cartNotif._timer);
      cartNotif._timer = setTimeout(function () {
        cartNotif.classList.remove('is-visible');
      }, 3500);
    }
  
    /* ─────────────────────────────────────────
       7. DRAWER QTY AANPASSEN / VERWIJDEREN
    ───────────────────────────────────────── */
    var drawerItems = document.getElementById('cart-drawer-items');
    if (drawerItems) {
      drawerItems.addEventListener('click', function (e) {
        var key = null;
  
        // Dec
        var decBtn = e.target.closest('.drawer-qty-dec');
        if (decBtn) {
          key = decBtn.dataset.key;
          var input = drawerItems.querySelector('.drawer-qty-input[data-key="' + key + '"]');
          var newQty = Math.max(0, parseInt(input.value) - 1);
          updateDrawerItemQty(key, newQty);
          return;
        }
  
        // Inc
        var incBtn = e.target.closest('.drawer-qty-inc');
        if (incBtn) {
          key = incBtn.dataset.key;
          var input2 = drawerItems.querySelector('.drawer-qty-input[data-key="' + key + '"]');
          updateDrawerItemQty(key, parseInt(input2.value) + 1);
          return;
        }
      });
    }
  
    function updateDrawerItemQty(key, qty) {
      var donationVariantId = window.themeSettings && window.themeSettings.donationVariantId;
      var isDonationKey = donationVariantId && key.split(':')[0] === String(donationVariantId);
  
      fetch(cartUrl('cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // Removing the last non-donation item should also remove the
          // donation - it shouldn't be left alone in an otherwise-empty cart.
          if (!isDonationKey && qty === 0 && donationVariantId) {
            var donationItem = cart.items.find(function (item) { return item.variant_id === donationVariantId; });
            var remaining = cart.item_count - (donationItem ? donationItem.quantity : 0);
            if (donationItem && remaining === 0) {
              fetch(cartUrl('cart/change.js'), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: donationItem.key, quantity: 0 })
              })
                .then(function (r) { return r.json(); })
                .then(function (finalCart) {
                  updateCartUI(finalCart);
                  renderDrawerItems(finalCart);
                });
              return;
            }
          }
          updateCartUI(cart);
          renderDrawerItems(cart);
        });
    }
  
    /* ─────────────────────────────────────────
       7b. DONATION CHECKBOX
    ───────────────────────────────────────── */
    var donationCheckbox = document.getElementById('drawer-donation-checkbox');
    if (donationCheckbox) {
      donationCheckbox.addEventListener('change', function () {
        var variantId = parseInt(donationCheckbox.dataset.variantId);
        if (donationCheckbox.checked) {
          fetch(cartUrl('cart/add.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          }).then(function () { refreshCartDrawer(); });
        } else {
          fetch(cartUrl('cart.js'))
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var donationItem = cart.items.find(function (item) { return item.variant_id === variantId; });
              if (!donationItem) return;
              return fetch(cartUrl('cart/change.js'), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: donationItem.key, quantity: 0 })
              });
            })
            .then(function () { refreshCartDrawer(); });
        }
      });
    }
  
    function renderDrawerItems(cart) {
      if (!drawerItems) return;
  
      if (!cart.items || cart.items.length === 0) {
        drawerItems.innerHTML =
          '<div class="cart-drawer__empty">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="#ddd"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13l-1.5 6h13"/></svg>' +
          '<p>' + t('text-js-cart-empty', 'Je winkelwagen is leeg.') + '</p>' +
          '<button class="btn btn--primary btn--sm" id="drawer-continue-shopping">' + t('text-js-continue-shopping', 'Verder winkelen') + '</button>' +
          '</div>';
        document.getElementById('drawer-continue-shopping')?.addEventListener('click', closeCartDrawer);
        return;
      }
  
      var html = '';
      // Shopify's cart.js returns items newest-first; reverse so the first
      // item added stays on top and new additions land at the bottom. The
      // donation line (if present) always renders last regardless of when
      // it was actually added.
      var donationVariantId = window.themeSettings && window.themeSettings.donationVariantId;
      var reversedItems = cart.items.slice().reverse();
      var displayItems = reversedItems.filter(function (item) { return item.variant_id !== donationVariantId; });
      var donationDisplayItem = reversedItems.find(function (item) { return item.variant_id === donationVariantId; });
      if (donationDisplayItem) displayItems.push(donationDisplayItem);
      displayItems.forEach(function (item) {
        var imgHtml = item.image
          ? '<div class="cart-drawer__item-img-wrap"><img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" width="65" height="65" loading="lazy"></div>'
          : '<div class="cart-drawer__item-img-wrap"><div class="cart-drawer__item-img-placeholder">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" viewBox="0 0 24 24" stroke="#ccc">' +
            '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M4 16l4.586-4.586a2 2 0 0 1 2.828 0L16 16m-2-2l1.586-1.586a2 2 0 0 1 2.828 0L20 14m-6-6h.01M6 20h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2z"/>' +
            '</svg></div></div>';
        var hasRealVariant = item.variant_title && item.variant_title !== 'Default Title';
        var displayTitle = hasRealVariant ? item.variant_title : item.product_title;
        var isRestrictDeItem = !!restrictedCartDisplay[String(item.variant_id)] || !!(item.properties && item.properties._restrict_de === 'true');
        var nlHandle = getStoredNlHandle(item.variant_id) || (item.properties && item.properties._nl_handle) || '';
        var variantHtml = hasRealVariant
          ? '<span class="cart-drawer__item-variant">' + t('text-js-qty-price-label', 'Aantal') + ' '+ item.quantity +' | ' + t('text-js-item-price-label', 'Prijs artikel') + ' '+ formatMoney(item.final_price) +'</span>'
          : '';
        var isDonationLine = donationVariantId === item.variant_id;
        var qtySelectorHtml = isDonationLine ? '' :
          '<div class="qty-selector qty-selector--sm">' +
          '<button type="button" class="qty-selector__btn drawer-qty-dec" data-key="' + item.key + '" aria-label="Minder">−</button>' +
          '<input type="number" class="qty-selector__input drawer-qty-input" value="' + item.quantity + '" min="0" data-key="' + item.key + '" aria-label="Aantal">' +
          '<button type="button" class="qty-selector__btn drawer-qty-inc" data-key="' + item.key + '" aria-label="Meer">+</button>' +
          '</div>';
        if (isDonationLine) {
          // Title and price side by side on one line - no qty selector, so the normal
          // bottom row would otherwise leave a visible empty gap. The image keeps the
          // same markup/column as every other item (no float/width override) so it
          // still lines up with the rest of the cart. Mirrors
          // snippets/cart-drawer-item.liquid's compact: true branch.
          // Display only - no link to a product (there's nothing to link to).
          html +=
            '<div class="cart-drawer__item cart-drawer__item--compact" data-key="' + item.key + '">' +
            '<div class="cart-drawer__item-img">' + imgHtml + '</div>' +
            '<div class="cart-drawer__item-info cart-drawer__item-info--compact">' +
            '<span class="cart-drawer__item-title">' + escapeHtml(displayTitle) + '</span>' +
            '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
            '</div>';
        } else {
          html +=
            '<div class="cart-drawer__item" data-key="' + item.key + '">' +
            '<a href="' + item.url + '" class="cart-drawer__item-img">' + imgHtml + '</a>' +
            '<!-- JS --><div class="cart-drawer__item-info">' +
            '<a href="' + item.url + '" class="cart-drawer__item-title" data-restrict-de-item="' + isRestrictDeItem + '" data-nl-handle="' + escapeHtml(nlHandle) + '" data-product-handle="' + item.handle + '" data-variant-id="' + item.variant_id + '">' + escapeHtml(displayTitle) + '</a>' +
            variantHtml +
            '<div class="cart-drawer__item-bottom">' +
            qtySelectorHtml +
            '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
            '</div>' +
            '</div>';
        }
      });
      drawerItems.innerHTML = html;
      fixRestrictedCartItemNames();
  
      // Voortgangsbalk gratis verzending bijwerken
      var freeThreshold = 5000;
      var shippingBar = document.getElementById('drawer-shipping-bar');
      if (shippingBar) {
        if (cart.total_price >= freeThreshold) {
          shippingBar.innerHTML = '<p class="cart-drawer__shipping-msg cart-drawer__shipping-msg--free">' + t('text-js-free-shipping-toast', 'Je hebt gratis verzending!') + '</p>';
        } else {
          var remaining = formatMoney(freeThreshold - cart.total_price);
          var pct = Math.round(cart.total_price * 100 / freeThreshold);
          shippingBar.innerHTML =
            '<p class="cart-drawer__shipping-msg">' + t('text-js-shipping-remaining-prefix', 'Nog') + ' <strong>' + remaining + '</strong> ' + t('text-js-shipping-remaining-suffix', 'voor gratis verzending') + '</p>' +
            '<div class="shipping-progress"><div class="shipping-progress__bar" style="width:' + pct + '%"></div></div>';
        }
      }
    }
  
    function escapeHtml(str) {
      return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
  
    /* ─────────────────────────────────────────
       8. COLLECTION SORT + FILTERS
    ───────────────────────────────────────── */
    document.getElementById('sort-select')?.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  
    var filtersSidebar = document.querySelector('.collection-sidebar');
    document.getElementById('open-filters')?.addEventListener('click', function () {
      filtersSidebar?.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
    document.getElementById('close-filters')?.addEventListener('click', function () {
      filtersSidebar?.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  
    document.querySelectorAll('.filter-group__toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body = this.nextElementSibling;
        var isOpen = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', String(!isOpen));
        body.style.display = isOpen ? 'none' : '';
        var arrow = this.querySelector('.filter-arrow');
        if (arrow) arrow.style.transform = isOpen ? 'rotate(-90deg)' : '';
      });
    });
  
    document.getElementById('filters-form')?.addEventListener('submit', function (e) {
      e.preventDefault();
      var url = new URL(window.location.href);
      url.search = '';
      new FormData(this).forEach(function (val, key) {
        if (val) url.searchParams.append(key, val);
      });
      var sortVal = document.getElementById('sort-select')?.value;
      if (sortVal) url.searchParams.set('sort_by', sortVal);
      window.location.href = url.toString();
    });
  
    /* ─────────────────────────────────────────
       9. PRODUCT PAGINA
    ───────────────────────────────────────── */
  
    // Thumbnail gallery
    document.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        document.querySelectorAll('.product-gallery__thumb').forEach(function (t) { t.classList.remove('is-active'); });
        this.classList.add('is-active');
        var mainImg = document.getElementById('main-product-image');
        if (mainImg) mainImg.src = this.dataset.src;
      });
    });
  
    // Variant kiezer
    var variantDataEl = document.getElementById('variant-data');
    var variantData   = variantDataEl ? JSON.parse(variantDataEl.textContent) : [];
  
    document.querySelectorAll('.variant-option__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var optionName = this.dataset.option;
        document.querySelectorAll('.variant-option__btn[data-option="' + optionName + '"]')
          .forEach(function (b) { b.classList.remove('is-selected'); });
        this.classList.add('is-selected');
        updateSelectedVariant();
      });
    });
  
    function updateSelectedVariant() {
      if (!variantData.length) return;
      var selected = {};
      document.querySelectorAll('.variant-option__btn.is-selected').forEach(function (btn) {
        selected[btn.dataset.option] = btn.dataset.value;
      });
      var keys    = Object.keys(selected);
      var matched = variantData.find(function (v) {
        return v.options.every(function (opt, i) { return selected[keys[i]] === opt; });
      });
      if (matched) {
        var vidEl = document.getElementById('variant-id-input') || document.getElementById('variant-id');
        if (vidEl) vidEl.value = matched.id;
        var priceEl = document.getElementById('product-price');
        if (priceEl) priceEl.textContent = formatMoney(matched.price);
        var addBtn = document.getElementById('add-to-cart-btn');
        if (addBtn) {
          addBtn.disabled = !matched.available;
          addBtn.textContent = matched.available ? t('text-js-in-cart-btn', 'In winkelwagen') : t('text-js-out-of-stock-btn', 'Niet op voorraad');
          addBtn.style.background = matched.available ? '' : '#bdc3c7';
        }
        if (window.applyIpRestriction) window.applyIpRestriction();
      }
    }
  
    // Product tabs
    document.querySelectorAll('.product-tabs__tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        document.querySelectorAll('.product-tabs__tab').forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        document.querySelectorAll('.product-tabs__panel').forEach(function (p) {
          p.classList.remove('is-active');
          p.hidden = true;
        });
        this.classList.add('is-active');
        this.setAttribute('aria-selected', 'true');
        var panel = document.getElementById(this.getAttribute('aria-controls'));
        if (panel) { panel.classList.add('is-active'); panel.hidden = false; }
      });
    });
  
    /* ─────────────────────────────────────────
       10. CART PAGINA QTY
    ───────────────────────────────────────── */
    function updateCartLineQty(line, qty) {
      fetch(cartUrl('cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line), quantity: parseInt(qty) })
      }).then(function () { window.location.reload(); });
    }
  
    document.querySelectorAll('.qty-dec').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = document.querySelector('.cart-qty-input[data-line="' + this.dataset.line + '"]');
        if (input) { var v = Math.max(0, parseInt(input.value) - 1); input.value = v; updateCartLineQty(this.dataset.line, v); }
      });
    });
    document.querySelectorAll('.qty-inc').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = document.querySelector('.cart-qty-input[data-line="' + this.dataset.line + '"]');
        if (input) { var v = parseInt(input.value) + 1; input.value = v; updateCartLineQty(this.dataset.line, v); }
      });
    });
  
    /* ─────────────────────────────────────────
       11. FAQ HELP PAGINA ACCORDEON
    ───────────────────────────────────────── */
    document.querySelectorAll('.faq-item__question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var answer = this.nextElementSibling;
        var isOpen = !answer.hidden;
        document.querySelectorAll('.faq-item__answer').forEach(function (a) { a.hidden = true; });
        document.querySelectorAll('.faq-item__question').forEach(function (b) {
          b.classList.remove('is-open');
          b.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          answer.hidden = false;
          this.classList.add('is-open');
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });
  
    // Help-pagina zoekfilter
    document.getElementById('help-search-input')?.addEventListener('input', function () {
      var q = this.value.toLowerCase();
      document.querySelectorAll('.faq-item').forEach(function (item) {
        item.style.display = q === '' || item.textContent.toLowerCase().includes(q) ? '' : 'none';
      });
      document.querySelectorAll('.help-section').forEach(function (section) {
        var hasVisible = Array.from(section.querySelectorAll('.faq-item')).some(function (i) { return i.style.display !== 'none'; });
        section.style.display = (q.length > 0 && !hasVisible) ? 'none' : '';
      });
    });
  
    /* ─────────────────────────────────────────
       12. SMOOTH ANCHOR SCROLL
    ───────────────────────────────────────── */
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  
    // DISCLAIMER MODAL - Footer.liquid file   
    const disclaimer_modal = document.getElementById('disclaimer-modal');
    window.openCartDisclaimerModal = function(variantId, quantity)
    {
      var el = document.getElementById('disclaimer-variantId'); 
      if( el ) el.value =  variantId;
      
      var el = document.getElementById('disclaimer-quantity');
      if( el ) el.value =  quantity; 
      
      disclaimer_modal.classList.add('active');    
    }
    document.querySelector('.disclaimer-modal__close')
      .addEventListener('click', function(){
        localStorage.setItem('disclaimerAccepted', '1');
        disclaimer_modal.classList.remove('active');
      });
    document.querySelector('.disclaimer-modal__overlay')
      .addEventListener('click', function(){
        disclaimer_modal.classList.remove('active');
      });
  
    /* ─────────────────────────────────────────
       13. EQUALIZE PRODUCT-CARD NAME HEIGHTS
       Product names in .product-card__name wrap to different
       line counts, which misaligns the price/button below them
       across cards in the same row. Groups all .product-card__name
       elements on the page by their rendered row (same viewport
       top), then sets every name in a row to the tallest one's
       height. Re-runs on resize since Bootstrap columns reflow at
       breakpoints. Exposed on window so AJAX-injected product
       cards (e.g. related-products.js) can re-trigger it after
       new markup is inserted.
    ───────────────────────────────────────── */
    function equalizeProductCardNames() {
      var names = Array.prototype.filter.call(
        document.querySelectorAll('.product-card__name'),
        function (el) { return !el.closest('.sw-collapse-item__content .variant-row-fill'); }
      );
      if (!names.length) return;
      names.forEach(function (el) { el.style.height = 'auto'; });
      var rows = {};
      names.forEach(function (el) {
        var top = Math.round(el.getBoundingClientRect().top);
        if (!rows[top]) rows[top] = [];
        rows[top].push(el);
      });
      Object.keys(rows).forEach(function (top) {
        var group = rows[top];
        var maxHeight = 0;
        group.forEach(function (el) { maxHeight = Math.max(maxHeight, el.offsetHeight); });
        group.forEach(function (el) { el.style.height = maxHeight + 'px'; });
      });
    }
    window.equalizeProductCardNames = equalizeProductCardNames;
  
    equalizeProductCardNames();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(equalizeProductCardNames);
    }
    var productCardResizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(productCardResizeTimer);
      productCardResizeTimer = setTimeout(function () {
        equalizeProductCardNames();
        equalizeVariantRowFillNames();
      }, 150);
    });
  
    /* ─────────────────────────────────────────
       13b. EQUALIZE VARIANT-ROW-FILL NAME HEIGHTS (per accordion section)
       main-collection-grouped.liquid's variant grid (.variant-row-fill) lives inside a
       collapsible accordion (.sw-collapse-item__content) that's hidden until opened. The
       page-wide row-detection equalizer above can't handle this correctly - a closed
       accordion's names measure as zero-height when the page first loads, and nothing
       re-triggers the check when the section is later opened, so the CSS min-height fallback
       is all that ever applies. This equalizes independently, per accordion section: every
       .product-card__name inside ONE .variant-row-fill container is set to that container's
       own tallest name, regardless of which wrapped sub-row it's on (a uniform height per
       product section, not per visual row) - matching the requested "per section" behavior.
       Skips containers that are currently hidden (maxHeight 0) rather than forcing height:0 -
       it re-runs when that section is opened instead. Exposed on window so
       sw-collapse-accordion.js can call it after each open/toggle completes.
    ───────────────────────────────────────── */
    function equalizeVariantRowFillNames() {
      var containers = document.querySelectorAll('.sw-collapse-item__content .variant-row-fill');
      containers.forEach(function (container) {
        var names = container.querySelectorAll('.product-card__name');
        if (!names.length) return;
        names.forEach(function (el) { el.style.height = 'auto'; });
        var maxHeight = 0;
        names.forEach(function (el) { maxHeight = Math.max(maxHeight, el.offsetHeight); });
        if (maxHeight === 0) return;
        names.forEach(function (el) { el.style.height = maxHeight + 'px'; });
      });
    }
    window.equalizeVariantRowFillNames = equalizeVariantRowFillNames;
  
    equalizeVariantRowFillNames();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(equalizeVariantRowFillNames);
    }
  
  })();